import { INIT_APP, VARIFY_OTP, PMS_CODE, MENU_ROLE_WISE, MASTER_MENU, POPUP_MENU } from "../types/initApp"; //SA Changes made for handling Popup --Abhishek

export const initApp = (payload) => ({
    type: INIT_APP,
    payload
})

export const varifyOtp = (payload) => ({
    type: VARIFY_OTP,
    payload
})

export const getPMSCode = (payload) => ({
    type: PMS_CODE,
    payload
})

export const menuRoleWise = (payload) => ({
    type: MENU_ROLE_WISE,
    payload,
})

export const masterMenu = () => ({
    type: MASTER_MENU,
})

//SA Changes made for handling Popup --Abhishek
//SA Code commented for DXTech issue
// export const popupmenu = (payload) => ({
//     type: POPUP_MENU,
//     payload
// })
//EA Code commented for DXTech issue
//EA Changes made for handling Popup --Abhishek




